

























import { Component, Vue } from 'vue-property-decorator'
import mock from '../../mock/DirectionAndProject';
import $api from '../../api';
import { Loading , Notification} from 'element-ui';

@Component
export default class Direction extends Vue{
  private contentDirection: string = '';
  private enContentDirection: string = '';
  private contentProject: string = '';
  private enContentProject: string = '';
  private targetNameDirection: string = 'research_direct';
  private targetNameProject: string = 'research_project';

  private mounted() {
    this.getContent();
  }
  private getContent() {
    this.contentDirection = mock.ContentDirection;
    this.enContentDirection = mock.EnContentDirection;
    this.contentProject = mock.ContentProject;
    this.enContentProject = mock.EnContentProject;
    // const loadInstance = Loading.service({target: '.ql-editor'});
    // $api.module.findContentByName(this.targetNameDirection)
    //     .then((res) => {
    //       this.contentDirection = (res as any).content;
    //       loadInstance.close();
    //     }).catch((error) => {
    //   loadInstance.close();
    //   // Notification({
    //   //   title: '网络异常',
    //   //   message: error,
    //   //   type: 'error',
    //   // });
    // })
    // $api.module.findContentByName('en_' + this.targetNameDirection)
    //     .then((res) => {
    //       this.enContentDirection = (res as any).content;
    //     })

    // $api.module.findContentByName(this.targetNameProject)
    //     .then((res) => {
    //       this.contentProject = (res as any).content;
    //       loadInstance.close();
    //     }).catch((error) => {
    //   loadInstance.close();
    //   Notification({
    //     title: '网络异常',
    //     message: error,
    //     type: 'error',
    //   });
    // })
    // $api.module.findContentByName('en_' + this.targetNameProject)
    //     .then((res) => {
    //       this.enContentProject = (res as any).content;
    //     })
  }
}
